import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { CustomCheckboxWrapper } from '../../components';
import { CustomFormItem } from '../../../custom_shared/components';
import { InputModel } from '../../models';
import { InputWithMeta } from '../../componentTypes';

// Please note that this is a generic component if behavior for your input is different - create a new independent component (like BusinessTypeInput.tsx etc.)

interface Props {
    label: string;
    input: InputModel;
}

const GenericCheckbox: InputWithMeta<Props> = ({ label, input }) => (
    <CustomFormItem name={input.guid} valuePropName="checked" isReadOnly={input.isReadOnly}>
        <CustomCheckboxWrapper label={label} input={input} />
    </CustomFormItem>
);

GenericCheckbox.meta = {
    inputType: InputModel.name
};

export default observer(GenericCheckbox);
